/**
 * AppleKpi — Tarjeta KPI con estética Apple Privacy.
 *
 * Estructura visual (replica exactamente la referencia Apple ID):
 *   ┌──────────────────────────────┐
 *   │ [icon] Title                 │  ← icono negro + título bold
 *   │ Description (2 lines)        │  ← descripción secundaria
 *   │                              │
 *   │ Label                        │  ← etiqueta pequeña
 *   │ VALUE                        │  ← valor grande bold
 *   │ ────────────────────────────│
 *   │ Footer                       │  ← texto helper abajo
 *   └──────────────────────────────┘
 *
 * Props:
 *  - icon        Component (lucide/phosphor icon)
 *  - title       string
 *  - description string | ReactNode   (opcional, 2 líneas máx)
 *  - label       string                (ej. "Programadas")
 *  - value       string | number       (ej. "0/0", "$1720")
 *  - footer      string | ReactNode    (opcional, texto gris pequeño)
 *  - testid      string                (data-testid del contenedor)
 *  - onClick     function              (opcional, convierte en clickeable)
 */
export default function AppleKpi({
  icon: Icon,
  title,
  description,
  label,
  value,
  footer,
  testid,
  onClick,
}) {
  const Wrapper = onClick ? "button" : "div";
  const extra = onClick
    ? "text-left w-full hover:bg-[#EDEDF0] active:scale-[0.995] transition"
    : "";
  return (
    <Wrapper
      type={onClick ? "button" : undefined}
      onClick={onClick}
      className={`rounded-[22px] bg-[#F5F5F7] p-5 flex flex-col h-full ${extra}`}
      data-testid={testid}
    >
      {/* Icon + title */}
      <div className="flex items-center gap-2">
        {Icon && (
          <Icon
            className="w-[18px] h-[18px] text-black flex-shrink-0"
            strokeWidth={1.75}
            weight="regular"
          />
        )}
        <div className="text-[15px] font-semibold text-black tracking-tight truncate">
          {title}
        </div>
      </div>

      {/* Description */}
      {description && (
        <div className="mt-2 text-[12.5px] leading-snug text-black/60 line-clamp-2 min-h-[32px]">
          {description}
        </div>
      )}

      {/* Label + big value */}
      <div className={description ? "mt-3" : "mt-4"}>
        {label && <div className="text-[12px] text-black/55">{label}</div>}
        <div className="text-[26px] font-bold text-black tracking-tight leading-tight mt-0.5">
          {value}
        </div>
      </div>

      {/* Divider + footer */}
      {footer !== undefined && footer !== null && footer !== "" && (
        <div className="mt-4 pt-3 border-t border-black/[0.08] text-[11.5px] text-black/55">
          {footer}
        </div>
      )}
    </Wrapper>
  );
}
